<template>
  <div>
    <template v-if="!forgotPassword">
      <b-jumbotron :lead="$t('label.bo_login')" />
      <b-form @submit="onSubmit">
        <b-form-group
          id="g_input-email"
          :label="$t('label.identifiant')"
          label-for="input-email"
        >
          <b-form-input
            id="input-email"
            v-model="form.email"
            type="text"
            required
          />
        </b-form-group>

        <b-form-group
          id="g_input-password"
          :label="$t('label.password')"
          label-for="input-password"
        >
          <b-form-input
            id="input-password"
            v-model="form.password"
            type="password"
            required
          />
        </b-form-group>
        <b-link @click="goToForgotPassword" class="d-block mb-3 text-black-50">
          <small>{{ $t("btn.password_first_connect_or_lost") }}</small>
        </b-link>

        <b-container>
          <b-row>
            <b-col>
              <b-button
                @click="login()"
                :variant="btnConnexionEnable ? 'primary' : 'secondary'"
                :title="$t('btn.connect')"
                :disabled="!btnConnexionEnable"
              >
                {{ $t("btn.connect") }} &#10004;</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </template>
    <template v-else-if="forgotPassword">
      <h3>{{ $t("label.please_mail") }}</h3>
      <b-form-group
        id="g_forgot_input-email"
        label="Identifiant"
        label-for="forgot_input-email"
      >
        <b-form-input
          id="forgot_input-email"
          v-model="form.email"
          type="text"
          required
        />
      </b-form-group>

      <b-container>
        <b-row>
          <b-col>
            <b-button
              variant="success"
              @click="goToLogin()"
              :title="$t('btn.back')"
            >
              <font-awesome-icon :icon="['fas', 'caret-left']" />
              {{ $t("btn.back") }}
            </b-button>
          </b-col>
          <b-col>
            <b-button
              :variant="btnResetEnable ? 'primary' : 'secondary'"
              :disabled="!btnResetEnable"
              @click="resetPwd()"
              :title="$t('btn.reset')"
              >{{ $t("btn.reset") }}</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>
<script>
import { Login, PasswordReset } from "../services/account";

export default {
  data() {
    return {
      forgotPassword: false,
      form: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    btnConnexionEnable() {
      return (
        this.form.email.length > 0 &&
        this.checkMail(this.form.email) &&
        this.form.password.length > 0
      );
    },
    btnResetEnable() {
      return this.form.email.length > 0 && this.checkMail(this.form.email);
    },
  },
  methods: {
    checkMail(mail) {
      return /^[a-z0-9][a-z0-9-_+\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(
        mail
      );
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.login();
    },
    async login() {
      const resp = await Login(this.form.email, this.form.password);
      if (resp) {
        this.$router.push("/");
      } else {
        this.showToast("danger", this.$t("error.identifiant_invalid"));
      }
    },
    goToForgotPassword() {
      this.forgotPassword = true;
    },
    goToLogin() {
      this.forgotPassword = false;
    },
    async resetPwd() {
      try {
        const res = await PasswordReset({
          mail: this.form.email.replace(/\s/g, ""),
        });
        if (res) {
          this.showToast(
            "succes",
            this.$t("msg.text.success_send_mail"),
            this.$t("msg.title.reset_password")
          );
        } else {
          this.showToast(
            "danger",
            this.$t("error.general"),
            this.$t("msg.title.reset_password")
          );
        }
      } catch (e) {
        this.showToast(
          "danger",
          this.$t("error.general"),
          this.$t("msg.title.reset_password")
        );
      }
    },
  },
};
</script>
